var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    })
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    fill: "#333",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 4.55c32.832 0 59.45 26.618 59.45 59.45 0 32.832-26.618 59.45-59.45 59.45-32.832 0-59.45-26.618-59.45-59.45C4.55 31.168 31.169 4.55 64 4.55M64 0C28.71 0 0 28.71 0 64s28.71 64 64 64 64-28.71 64-64S99.29 0 64 0m10.414 12.762c-5.215-.95-17.824 18.203-21.996 29.867-.316.883-1.043 4.125-1.043 4.976 0 0 3.266 7.028 4.172 8.676-1.516-.789-4.66-6.879-4.66-6.879-1.52 2.895-2.973 16.172-2.5 18.637 0 0 3.383 5.031 4.695 6.29-1.8-.602-4.836-4.677-4.836-4.677-.57 1.754-.457 5.403-.191 6.637 2.277 3.316 5.312 3.695 5.312 3.695s-3.32 33.094 1.707 35.559c3.13-.664 3.887-36.98 3.887-36.98s3.793.285 4.644-.665c1.93-1.324 6.415-15.109 6.48-17.097 0 0-5.206.972-7.745 1.96 1.914-1.902 8.027-3.175 8.027-3.175 1.656-1.992 5.145-15.523 5.496-19.695.086-1.047.293-2.328.133-4.2 0 0-4.969 1.086-6.008.711 1.055-.117 6.133-2.07 6.133-2.07.902-8.105 1.18-21.047-1.707-21.57zM56.227 98.609c-.399 9.746-.649 12.5-1.059 14.797-.191.43-.379.5-.57-.047-1.739-7.996-1.61-68.218 18.207-95.62-11.528 21.046-16.77 61.433-16.578 80.87zm0 0"
  }));
};